import type { TShoppableGalleryDependencies } from './types/shoppableGalleryDependencies';

import { onContainerChanges } from '../stories/utils/onContainerChanges/onContainerChanges';
import { SyteApi } from '../../lib/api/syte-api';
import Logger from '../../logger';
import type { TGalleryItem } from './types/galleryItem';
import { gallerySelector, bannerSelector } from './consts/gallerySelectors';
import { loadImageAsync } from './components/utils/loadImageAsync';

export async function init(dependencies: TShoppableGalleryDependencies) {
  const containerChangesCallback: Parameters<typeof onContainerChanges>[1] = async element => {
    try {
      const response = await SyteApi.getGalleryOffers();

      if (!response) {
        Logger.error('there is an error fetching shoppable galleries offers');
        return;
      }

      if (!response.images || !response.images.length) {
        Logger.log('no images to show in the shoppable galleries');
        return;
      }

      if (dependencies.processGalleryResponse) {
        response.images = response.images.map(galleryItem => dependencies.processGalleryResponse!(galleryItem));
      }

      const imageLoadPromises: Promise<TGalleryItem | null>[] = response.images.map(galleryItem => loadImageAsync(galleryItem));
      response.images = (await Promise.all(imageLoadPromises)).filter(galleryItem => galleryItem) as TGalleryItem[];

      if (!response.images.length) {
        Logger.log('no images loaded successfully in shoppable galleries');
        return;
      }

      const shadowElement = element.attachShadow({ mode: 'open' });

      const { renderShoppableGallery } = await import('./ShoppableGalleryRender');
      renderShoppableGallery(shadowElement, dependencies.customStyles, dependencies.customOptions, response);
    } catch (error) {
      Logger.error('the shoppable galleries init function encountered an error in containerChangesCallback', error);
    }
  };

  onContainerChanges(`${gallerySelector}, ${bannerSelector}`, containerChangesCallback);
}
